<template>
    <div class="progressive" @click="open">
        <img  @load="placeholderEnd" v-if="paths.smallImage" class="img placeholder" :src="paths.smallImage"/>
    </div>

</template>
<script>
import {ImageManager} from "@/manager/ImageManager";
import {Utils} from "@/Utils/Utils";

export default {
    name: "MyImage",
    props: {
        info: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            paths: {},
        }
    },
    created() {
        this.paths = Utils.getALLImagePath(this.info.imageName, this.info.position)
    },
    methods: {
        placeholderEnd(e) {
            console.log('预览图加载成功')
            let imageOrigin = new Image()
            imageOrigin.style.display = 'none'
            let target = e.target
            imageOrigin.onload =  ()=> {
                imageOrigin.style.display = ''
                target.parentElement.removeChild(target)
            };
            imageOrigin.src = this.paths.showImage
            e.target.parentElement.appendChild(imageOrigin)
            ImageManager.setImage(imageOrigin)
        },
        open(){
            if(this.paths.realImage){
                this.$emit('open',this.paths.realImage,this.info.name)
            }

        }
    }
}
</script>
<style scoped lang="less">
.progressive {
    width: 100%;
    height: 100%;
    position: relative;

}

.img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    transition: all 0.6s;
}
.placeholder{
    filter: blur(2px);
}
</style>
